import React, { useEffect, useState } from 'react';
import axiosInstance from '../../../../redux/api';
import { urtoast } from '../../../Layouts/CustomPopup/eventEmitter';

export default function Check401Api() {
    const [loading, setLoading] = useState(false);

    const checkApi = async () => {
        setLoading(true);
        try {
            const response = await axiosInstance.get('test');
            console.log("API Response:", response);
            urtoast(response?.data?.response?.message || "Request Successful", 1);
        } catch (error) {
            console.error("API Error:", error);
            // Error handling is already done in axiosInstance interceptor
            // but we can add specific handling here if needed.
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {/* <div className="p-4 border rounded shadow-sm bg-white" style={{ margin: '20px' }}>
                <h5 className="mb-3">API Test Component</h5>
                <p className="text-muted small mb-3">Click the button below to trigger an API call and test error handling (401/429).</p>
                <button
                    type="button"
                    className="btn btn-primary"
                    onClick={checkApi}
                    disabled={loading}
                >
                    {loading ? "Calling API..." : "Hit Test API"}
                </button>
            </div> */}
        </>
    );
}
